<script lang="ts">
  export let label: string = null;
  export let onClick: () => void = null;
</script>

<div on:click={() => onClick()}>
  {label}
</div>
